import { createHandoverApi } from './handoverApi';

const MaintenanceControlApi = createHandoverApi({
    basePath: 'MaintenanceControlHandOver',
    reportName: 'MaintenanceControl',
});

export default MaintenanceControlApi;
